import React, { useState } from "react";
import { Checkbox, Stack } from "@mui/material";
import {
  AuthTextField,
  CheckboxLabel,
  Container,
  InputLabel,
  LoginLabelLink,
  SignupButton,
  Title,
} from "./register.components";
import { Link, useNavigate } from "react-router-dom";
import { homepage, loginLink } from "../../../common/routes";
import { useAlert } from "react-alert";
import { registerUser } from "../../../services/auth";
import { useCookies } from "react-cookie";

function Register() {
  const alert = useAlert();
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailID, setEmailID] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [hasAgreedTandC, setHasAgreedTandC] = useState(false);
  const path = "/";
  const domain = window.location.hostname;

  if (cookies.token !== undefined && cookies.token !== "undefined")
    navigate(homepage);

  const handleRegiter = async () => {
    if (validate()) {
      const userData = {
        firstName: firstName,
        lastName: lastName,
        emailID: emailID,
        phoneNumber: phone,
        password: password,
        referralCode: referralCode,
      };
      await registerUser(userData)
        .then((response) => {
          if (response.status === 409) {
            alert.error(response.data.message);
            return;
          }
          if (response.data) {
            setCookie("emailID", response.data.emailID, { path, domain });
            setCookie("firstName", response.data.firstName, { path, domain });
            setCookie("lastName", response.data.lastName, { path, domain });
            setCookie("userID", response.data.userID, { path, domain });
            setCookie("token", response.data.token, { path, domain });
            alert.success(response.message);
            navigate(homepage);
          }
        })
        .catch((error) => console.log(error));
    }
  };

  return (
    <Container>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        spacing={2.5}
        sx={{ py: 5.75, width: 480, m: "auto" }}
      >
        <Title>Sign Up</Title>

        <Stack
          direction="row"
          justifyContent="center"
          alignItems="flex-end"
          spacing={2.5}
        >
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
          >
            <InputLabel>First Name</InputLabel>
            <AuthTextField
              value={firstName}
              setValue={setFirstName}
              type="text"
              fiftyPercent={230}
            />
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
          >
            <InputLabel>Last Name</InputLabel>
            <AuthTextField
              value={lastName}
              setValue={setLastName}
              type="text"
              fiftyPercent={230}
            />
          </Stack>
        </Stack>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <InputLabel>Email ID</InputLabel>
          <AuthTextField value={emailID} setValue={setEmailID} type="email" />
        </Stack>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <InputLabel>Phone no.</InputLabel>
          <AuthTextField value={phone} setValue={setPhone} type="text" />
        </Stack>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <InputLabel>Password</InputLabel>
          <AuthTextField
            value={password}
            setValue={setPassword}
            type="password"
          />
        </Stack>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <InputLabel>Referral code? (If any)</InputLabel>
          <AuthTextField
            value={referralCode}
            setValue={setReferralCode}
            type="text"
          />
        </Stack>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0.75}
          sx={{ mt: "15px !important" }}
        >
          <Checkbox
            sx={{ p: "0px !important" }}
            onChange={(e, value) => setHasAgreedTandC(value)}
          />
          <CheckboxLabel>Agree to our Terms and Conditions</CheckboxLabel>
        </Stack>
        <SignupButton onClick={handleRegiter}>Sign Up</SignupButton>
        <LoginLabelLink>
          Already have an account ?{" "}
          <LoginLabelLink component={Link} to={loginLink} linkColor="#1488CC">
            Sign in
          </LoginLabelLink>
        </LoginLabelLink>
      </Stack>
    </Container>
  );

  function validate() {
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;

    if (!firstName) {
      alert.error("please enter the first name");
      return false;
    }
    if (!lastName) {
      alert.error("please enter the last name");
      return false;
    }
    if (!emailID || !emailRegex.test(emailID)) {
      alert.error("please enter a valid email id");
      return false;
    }
    if (!phone || !phoneRegex.test(phone)) {
      alert.error("please enter a valid phone number");
      return false;
    }
    if (!password) {
      alert.error("please enter the password");
      return false;
    }
    if (!hasAgreedTandC) {
      alert.error("please accept the terms & conditions to register");
      return false;
    }
    return true;
  }
}

export default Register;
